import React, { Fragment } from 'react'
import { FormTextArea, FormDisplayErrors } from '@myxplor/forms'
import { Note } from '@myxplor/ui'

export const ChildSubmissionFields = ({ values, errors, onChange }) => (
  <fieldset>
    <legend>Run Submissions</legend>

    <ol>
      <li>
        Submissions must be provided to the government <strong>within 14 days</strong> after the end
        of the week when care was provided.
      </li>

      <li>
        Submissions can be updated <strong>until 28 days</strong> after the start of the week to
        which the submission relates (or until the end of the financial year, if that occurs
        sooner).
      </li>
    </ol>
    <Note important>
      If you are creating a new submission after the 14-day limit or updating a submission after the
      28-day limit, you will need to provide a reason for the late change for assessment by the
      Department of Education and Training.
      <FormTextArea
        name="late_submission_reason"
        label="Late Submission Reason"
        value={values.late_submission_reason}
        errors={errors.late_submission_reason}
        onChange={onChange}
        maxLength={1000}
        rows={2}
      />
    </Note>
  </fieldset>
)

export const ChildSubmissionDone = ({ errors = [] }) =>
  errors.length > 0 ? (
    <Fragment>
      CCS Submissions have been run but there were some errors...
      <FormDisplayErrors errors={errors} />
    </Fragment>
  ) : (
    <Fragment>All CCS Submissions were successfully run</Fragment>
  )



// WEBPACK FOOTER //
// ./src/session-summaries/details/run-submissions/fields.jsx